import type { RouteRecordRaw } from 'vue-router'
import { checkPermission } from '@/router/guards.ts'

const FuelStationModule = () => import('./FuelStationModule.vue')
const FuelStationIndex = () => import('./views/FuelStationIndex.vue')
const FuelStationView = () => import('./views/FuelStationView.vue')

export const fuelStationRoute: RouteRecordRaw = {
  path: '/fuel-stations',
  name: 'fuel-station',
  component: FuelStationModule,
  meta: {
    title: 'Fuel Stations',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'fuel-stations-index',
      component: FuelStationIndex,
      meta: {
        permission: 'station.view',
      },
      beforeEnter: checkPermission('station.view'),
    },
    {
      path: ':id',
      name: 'fuel-station-view',
      meta: {
        permission: 'station.view',
      },
      component: FuelStationView,
    },
  ],
}
